import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import * as actions from "../../actions";
import { Image as CloudinaryImage, Transformation } from "cloudinary-react";
import Image from "../Image/Image.jsx";
import { UncontrolledPopover, PopoverHeader, PopoverBody } from "reactstrap";

class ReportModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      timeout: ""
    };
  }
  componentDidMount() {
    this.props.getUser();
  }
  componentWillMount() {
    this.props.getReportModalReasonData();
  }
  giveReport = report => {
    const { data } = this.props;
    let reportData = {
      reasonId: report._id,
      mediaId: data._id,
      mediaUserId: data.userId,
      contestName: data.contestName
    };
    this.props.postReport(reportData);
  };
  render() {
    let { userData, reasons } = this.props;
    this.props.open && this.props.userData._id == ""
      ? this.props.getUser()
      : null;

    return (
      <div
        className="modal"
        id="ticketmodal"
        tabIndex="-1"
        role="dialog"
        aria-hidden="true"
        style={this.props.open ? { display: "block" } : {}}
        onClick={this.props.modalClose}
      >
        <div
          className="modal-dialog modal-sm modal-dialog-centered"
          role="document"
        >
          <div
            className="modal-content animated bounceIn"
            onClick={e => e.stopPropagation()}
          >
            <div className="ticket-modal">
              <React.Fragment>
                <div className="reportcontent">
                  <p className="mb-0 cotmed">Report</p>
                </div>
                <div className="modalmaincontent reportmaincontent">
                  <p className="text-center f-14">
                    Choose a reason for reporting this post.
                  </p>
                  {reasons !== undefined
                    ? reasons.map((item, index) => (
                        <a
                          key={"reasons" + index}
                          onClick={e => {
                            e.stopPropagation();
                            this.giveReport(item);
                            this.props.checkReport(this.props.data.e);
                          }}
                        >
                          {item.value}
                        </a>
                      ))
                    : null}
                </div>
              </React.Fragment>
              <div
                className="modalfooter pointer"
                onClick={() => {
                  this.props.modalClose();
                }}
              >
                <a className="">Cancel</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ reportModal, user }) => {
  const { open, reportList, reasons, data } = reportModal;
  const { userData } = user;
  return { open, userData, reportList, reasons, data };
};

const mapDispatchToProps = dispatch => ({
  modalClose: () => dispatch(actions.reportModalClose()),
  getUser: () => dispatch(actions.getUser()),
  giveVote: payload => dispatch(actions.giveVote(payload)),
  getReportModalReasonData: () => dispatch(actions.getReportModalReasonData()),
  postReport: payload => dispatch(actions.postReport(payload))
});

export default connect(mapStateToProps, mapDispatchToProps)(ReportModal);
